import React from 'react'

function Home() {
  return (
    <>
    <div>
        <div className='min-h-screen'>
            <img className='block md:hidden lg:hidden bg-cover py-32' src="Mobile.jpg" alt="" />
            <img className='hidden md:block lg:block' src="sTARTECK-WEBSITE-UNDER-CONSTRUCTION.jpg" alt="" />
        </div>
    </div>
    </>
  )
}

export default Home